<template>
    <div class="profile-grid">
      <ProfileCard
        v-for="(profile, index) in profiles"
        :key="index"
        :profile="profile"
      />
    </div>
  </template>
  
  <script>
  import ProfileCard from "./ProfileCard.vue";
  
  export default {
    name: "ProfileGrid",
    components: { ProfileCard },
    props: {
      profiles: Array
    }
  };
  </script>
  
  <style scoped>
  .profile-grid {
    display: grid;
    grid-template-columns: repeat(6, 1fr); /* 🖥 Desktop: 6 columns */
    gap: 20px;
  }

  /* 📲 Tablets (iPad portrait & landscape) */
    @media (max-width: 1024px) {
    .profile-grid {
        grid-template-columns: repeat(4, 1fr);
    }
    }
  
  /* 📱 Mobile */
  @media (max-width: 768px) {
    .profile-grid {
      grid-template-columns: repeat(2, 1fr); /* 2 columns */
      gap: 10px;
    }
  }
  </style>
  